import Entity from "./Entity";
import common from "../../common";
import FlockController from "../flocking/FlockController";

export default class BatObstacle extends Entity {

    get collider() {
        return this._collider;
    }

    constructor() {
        super(new PIXI.Point(), PIXI.Texture.EMPTY);

        this.tweens = new P3.utils.TWEEN.Group();

        this._activated = false;

        this._flockHolder = new PIXI.Container();
        this.addChild(this._flockHolder);

        const settings = {
            limits: {velocity: 320, force: 8},
            weights: {s: 2, a: 0.9, c: 0.8, t: 2},
            separation: 60,
            sense: 400,
            targeting: true,
            wrapAround: false,
            bounds: null,
        };

        this._flockHolder.y = -common.STAGE_HEIGHT * 0.25;
        this._flock = new FlockController(this._flockHolder, settings);
        this._flock.target = this._view.position.clone();
        this._flock.populate(6);
        this._flock.wake();

        this._collider = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._collider.tint = 0xff0000;
        this._collider.anchor.set(0.5, 1);
        this._collider.width = 60;
        this._collider.height = 80
        this._collider.renderable = false;
        this.addChild(this._collider);

        this.headCollision = true;

        this.startDistance = 1800;

    }

    start() {
        this.started = true;

        this._view.y = 600;
        this._flock.target.y = this._view.y + 60;
        this._collider.y = this._view.y;// + this._view.height;

    }

    update(dt) {
        this.tweens.update();
        this._flock.update(dt);
    }

    setCollider(x, y, width, height) {
        this._collider.x = x;
        this._collider.y = y;
        this._collider.width = width;
        this._collider.height = height;
    }

    hit() {
        if (!this._activated) {
            this._activated = true;
        }
    }

}